import { render, staticRenderFns } from "./ReportStatsCard.vue?vue&type=template&id=234e6c40&scoped=true&"
import script from "./ReportStatsCard.vue?vue&type=script&lang=js&"
export * from "./ReportStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatsCard.vue?vue&type=style&index=0&id=234e6c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e6c40",
  null
  
)

export default component.exports